<template>
  <form class="payment-options">
    <action-dispatcher action="product/getPaymentMethods">
      <h5 class="text-semibold mb-4">Formas de pagamento</h5>
      <snow-checkbox-group
        id="payment_methods"
        v-model="paymentInnerValue"
        :options="_paymentMethods"
        @input="updateValue"
      />
    </action-dispatcher>

    <snow-select
      v-model="form.order_installment"
      id="order_installment"
      label="Ordenação do parcelamento"
      :options="[
        { id: 'asc', name: 'Do menor para o maior' },
        { id: 'desc', name: 'Do maior para o menor' }
      ]"
      :errors="errors.order_installment"
    />
    <snow-switch
      label="Taxas para o produtor"
      info="Em uma compra parcelada, o produtor pagará as taxas do parcelamento"
      id="product-status"
      v-model="form.is_tax_to_producer"
    />
    <div class="d-flex flex-column gap-2 mb-4">
      <snow-select
        v-model="form.expire_billet"
        id="expire_billet"
        label="Prazo para vencimento do boleto"
        :options="expireBilletOptions"
        :errors="errors.expire_billet"
      />
      <span class="text-dark-40 fs-14">
        Este prazo não se aplica ao Multibanco. Neste caso, o prazo padrão será
        de 3 dias corridos.
      </span>
    </div>

    <div class="d-flex flex-column">
      <h5 class="text-semibold">
        Dias permitidos para gerar boleto no checkout
      </h5>
      <small class="text-dark-40 fs-12">
        Boletos emitidos aos sábados e domingos tem uma conversão 26% menor.
      </small>
    </div>
    <snow-checkbox-group
      v-model="form.allow_week_billet.week"
      id="allow_week_billet"
      :options="weekDays"
    />
  </form>
</template>

<script>
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      weekDays: [
        { id: 0, name: "Domingo" },
        { id: 1, name: "Segunda-feira" },
        { id: 2, name: "Terça-feira" },
        { id: 3, name: "Quarta-feira" },
        { id: 4, name: "Quinta-feira" },
        { id: 5, name: "Sexta-feira" },
        { id: 6, name: "Sábado" }
      ],
      expireBilletOptions: [
        { id: 1, name: "1 dia útil" },
        { id: 2, name: "2 dias úteis" },
        { id: 3, name: "3 dias úteis" },
        { id: 4, name: "4 dias úteis" },
        { id: 5, name: "5 dias úteis" }
      ],
      paymentInnerValue: [...this.form.payment_methods_ids]
    };
  },
  computed: {
    ...mapState("product", ["paymentMethods"]),
    _paymentMethods() {
      const warningsSignature = {
        3: "Esse tipo de pagamento não gerará assinatura do produto.",
        5: "Esse tipo de pagamento não gerará assinatura do produto."
      };

      const warningsEvent = {
        2: "Os pedidos dessa forma de pagamento receberão o status de ‘pendente’ e haverá reserva do estoque seguindo o prazo configurado para vencimento do boleto.",
        4: "Os pedidos dessa forma de pagamento receberão o status de ‘pendente’ e haverá reserva do estoque por um prazo de 24h."
      };

      const paymentMethods = [
        ...this.paymentMethods.map(m => ({
          id: m.id,
          name: m.name,
          disabled:
            (!!this.paymentInnerValue.includes(6) && m.id === 2) ||
            (!!this.paymentInnerValue.includes(2) && m.id === 6),
          warning:
            (this.form.type_product == "signature"
              ? warningsSignature[m.id]
              : null) ||
            (this.form.type_product == "onsite_event"
              ? warningsEvent[m.id]
              : null)
        }))
      ];

      return paymentMethods;
    },
    isValid() {
      return (
        this.form.expire_billet &&
        this.paymentInnerValue.length > 0 &&
        this.form.allow_week_billet?.week?.length > 0
      );
    }
  },
  methods: {
    updateValue() {
      this.form.payment_methods_ids = [...this.paymentInnerValue];
    }
  },
  watch: {
    isValid(newVal) {
      this.$emit("isValid", newVal);
    }
  },
  mounted() {
    this.$emit("isValid", this.isValid);
  }
};
</script>
<style lang="scss" scoped>
.payment-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
